import React, { Component } from 'react';
import './KPI5.css';

import Select from '@acri-tools/react-tools/components/Select/Select';
import KPIs from '../KPIs';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { IonCheckbox } from '@ionic/react';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL, axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import classNames from 'classnames';
import { connect } from 'react-redux';

interface Props {
    kpi?:any
}
interface State {
    loading: boolean

    data?: any

    selected:Array<string>

    // export
    json_format: boolean
}

/**
 *  1. SELECT KPI
 *  2. Table of all report with name, planned date, sent date, KPI value (1 point per day) checkbox per report for export
 */
class KPI5 extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            selected: [],
            json_format: false,
            loading: false,
        }
    }
    componentDidMount() {
        this.fetch_data()
    }
    // async componentDidUpdate(prevProps:Props) {
    //     if(prevProps.kpi?.refresh !== this.props.kpi?.refresh){
    //         await this.setState({
    //             ...this.default_values(true)
    //         })
    //         this.fetch_data(true)
    //     }
    // }

    fetch_data = async(refresh?:boolean) => {
        if(refresh) this.setState({ loading: true })
        try {
            let res = await request(`${API_URL}/api/v1/reporting`,{
                method:'get',
                responseType:'json',
                serializer:'json',
                params:{
                    limit: 4500,
                    orderby: 'planned_date_time asc'
                }
            })
            this.setState({ data:res.data.value });
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_kpi_data'
            })
        }
        finally {
            if(refresh) this.setState({ loading: false });
        }
    }
    render() {
        let today = new Date();
        return (
            <KPIs
                title="Service Reporting​"
            >

                {/* GRAPH */}
                <div className="title-3">Reports</div>
                {
                    this.state.loading ?
                        <div className="centered">
                            <Spinner />
                        </div>
                        :
                        this.state.data &&
                        <table className="table-kpi">
                            <thead>
                                <tr>
                                    <th>
                                        <IonCheckbox checked={this.state.selected.length === this.state.data?.length} onClick={(e:any)=>{
                                            if(this.state.selected.length === this.state.data?.length){
                                                this.setState({ selected: [] });
                                            }
                                            else{
                                                this.setState({ selected: this.state.data.map((d:any)=>{ return d.id }) });
                                            }
                                        }}/> All
                                    </th>
                                    <th>Attached File</th>
                                    <th>Planned Date</th>
                                    <th>Sending Date</th>
                                    <th>Type</th>
                                    <th>Delay</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.data?.map((r: any, key: number) => (
                                        <tr key={key}>
                                            <td>
                                                <IonCheckbox 
                                                    onClick={(e)=>{
                                                        let { selected } = this.state;
                                                        if(this.state.selected.includes(r.id)){
                                                            let idx = selected.indexOf(r.id);
                                                            selected.splice(idx, 1);
                                                        }
                                                        else{
                                                            selected.push(r.id)
                                                        }
                                                        this.setState({ selected })
                                                    }}
                                                    checked={this.state.selected.includes(r.id)} />
                                            </td>
                                            <td>{ r.attached_file }</td>
                                            <td>{ r.planned_date_time }</td>
                                            <td>
                                                {
                                                    r.sending_date_time ||
                                                    new Date(r.planned_date_time) <= today && <i>Not sent... </i>
                                                }
                                            </td>
                                            <td>
                                                { r.type }
                                            </td>
                                            <td>
                                                {
                                                    r.sending_date_time ?
                                                        this.date_day_diff(r.planned_date_time, r.sending_date_time)
                                                        :
                                                        new Date(r.planned_date_time) <= today ?
                                                            <>
                                                                {this.date_day_diff(r.planned_date_time, today.toDateString())}
                                                                <i>... </i>
                                                            </>
                                                            :
                                                            <i>-</i>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                }
                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a 
                    className={classNames({
                        "custom-button medium inline": true,
                        "disabled": this.state.selected.length === 0
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }

    download_url = () => {
        let params = [
            // 'expand=product,sensing_product',
            'export=true',
        ];
        params.push(`exports=${this.state.selected.join(',')}`);
        if(this.state.json_format) params.push('format=json');
        
        return `${API_URL}/api/v1/reporting?${params.join('&')}`
    }

    date_day_diff = (start: string, stop: string) => {
        let hours = Math.round(
            (new Date(stop).getTime() - new Date(start).getTime())
            / (1000 * 3600)
        )
        if (hours >= 24) {
            let days = (hours / 24);
            return `${days.toFixed(0)} Day${days >= 2 ? 's' : ''}`
        }
        return `${hours} Hour${hours !== 1 ? 's' : ''}`
    }

};


export default connect((state:any)=>{
    return {
        kpi: state.kpi
    }
})(KPI5)